// Reusable Card component for content sections
import React from 'react';

export function Card({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-zinc-900/60 border border-zinc-800 rounded-2xl p-5 pointer-events-auto">
      <div className="font-semibold mb-2">{title}</div>
      <div className="text-zinc-300 text-sm leading-relaxed">{children}</div>
    </div>
  );
}
